module.exports = __webpack_public_path__ + "static/media/mode-523.cf3ff77a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-523.svg
// module id = 1048
// module chunks = 2